import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/js/dist/collapse';

const Navbar: React.FC = () => {
  return (
    <>
      <div className="container-fluid border-bottom bg-light wow fadeIn" data-wow-delay="0.1s">
        <div className="container topbar bg-primary d-none d-lg-block py-2" style={{ borderRadius: '0 40px' }}>
          <div className="d-flex justify-content-between">
            <div className="top-info ps-2">
              <small className="me-3">
                <i className="fas fa-envelope me-2 text-secondary"></i>
                <a href="mailto:alanaenglishcenter@gmail.com" className="text-white">alanaenglishcenter@gmail.com</a>
              </small>
            </div>
            <div className="top-link pe-2">
              <a href="https://www.facebook.com/alanaenglishcenter" className="btn btn-light btn-sm-square rounded-circle">
                <i className="fab fa-facebook text-primary"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="container px-0">
          <nav className="navbar navbar-light navbar-expand-xl py-3">
            <Link to="/">
              <img src={process.env.PUBLIC_URL + '/img/logo.png'} alt="Alana English Center" height="60" />
            </Link>
            <button 
              className="navbar-toggler py-2 px-3" 
              type="button" 
              data-bs-toggle="collapse" 
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="fa fa-bars text-primary"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <div className="navbar-nav mx-auto">
              </div>
              <div className="d-flex me-4">
                <div id="phone-tada" className="d-flex align-items-center justify-content-center">
                  <a href="tel:02367302679" className="position-relative wow tada" data-wow-delay=".9s">
                    <i className="fa fa-phone text-primary fa-2x me-4"></i>
                    <div className="position-absolute" style={{ top: '-7px', left: '20px' }}>
                      <span><i className="fa fa-comment-dots text-secondary"></i></span>
                    </div>
                  </a>
                </div>
                <div className="d-flex flex-column p-3">
                  <span className="text-primary">Liên hệ</span>
                  <a href="tel:02367302679"><span className="text-secondary">0236 7302 679</span></a>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Navbar; 